const formatCurrency = (value, currency = 'TRY', locale = 'tr-TR') => {
  if (isNaN(value) || typeof value === 'string') {
    console.error('formatCurrency is only for numbers.');
    return '-';
  }
  try {
    if (value === undefined || value === null) return '-';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'symbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 5,
    }).format(value);
  } catch (e) {
    if (value === undefined || value === null) return '-';
    const amount = parseFloat(value);
    const formatted = amount.toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formatted + '₺';
  }
};

export { formatCurrency };
